/**
 * Gets the value of a specified query parameter from the URL
 * @param {string} paramName - The name of the query parameter to search for
 * @param {string} [url] - Optional URL string. If not provided, uses current window location
 * @returns {string|undefined} The value of the query parameter if found, otherwise undefined
 */
export function getQueryParamValue(paramName, url) {
  const searchParams = url
    ? new URLSearchParams(new URL(url).search)
    : new URLSearchParams(window.location.search);

  return searchParams.get(paramName) || undefined;
}
